import React, { FC, useMemo } from 'react'
import { Shared } from 'ui/shared'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepConnector from './components/StepConnector/StepConnector'
import StepIcon from './components/StepIcon/StepIcon'
import { makeStyles } from 'tss-react/mui'
import { StepIconProps, Typography } from '@mui/material'

const steps = ['created', 'booking_start', 'rent_start', 'rent', 'booking_finish', 'rent_finish', 'rent_completed']

type TProps = {
  className?: string
  status: string
  canceled: boolean
}

const RentStatusStepper: FC<TProps> = ({ className, status, canceled }) => {
  const { classes, cx } = useStyles()

  const getActiveStepIndex = (steps: string[], currentStatus: string) => {
    return steps.indexOf(currentStatus)
  }

  const activeStep = useMemo(() => getActiveStepIndex(steps, status), [status])

  return (
    <Shared.Card className={className}>
      <Stepper activeStep={activeStep} alternativeLabel className={classes.root} connector={<StepConnector />}>
        {steps.map((label, index) => {
          const isFirst = index === 0

          return (
            <Step key={label}>
              <StepLabel
                StepIconComponent={StepIcon}
                className={cx({
                  [classes.canceledLabel]: canceled && isFirst,
                })}
              >
                {label}
              </StepLabel>
              {canceled && isFirst && (
                <Typography variant="caption" className={classes.canceledText}>
                  Canceled
                </Typography>
              )}
            </Step>
          )
        })}
      </Stepper>
    </Shared.Card>
  )
}

export default RentStatusStepper

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: '0 !important',
    position: 'relative',

    '& .MuiStepLabel-label': {
      color: theme.palette.text.secondary,
      fontSize: 18,
      fontWeight: 400,
      textTransform: 'capitalize',
    },

    '& .MuiStepLabel-label.MuiStepLabel-active': {
      color: theme.palette.primary.main,
      fontWeight: 700,
    },

    '& .MuiStepLabel-label.MuiStepLabel-completed': {
      color: theme.palette.primary.main,
      fontWeight: 700,
    },
  },

  canceledLabel: {
    color: theme.palette.error.main + ' !important',
    fontWeight: 700,
  },
  canceledText: {
    color: theme.palette.error.main,
    fontSize: '0.75rem',
    marginTop: theme.spacing(0.5),
    textAlign: 'center',
    position: 'absolute',
    top: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
  },
}))
